import http from "../http-common";

class BannerService {
    getBanners() {
        return http.get("admin/banner/list");
    }
}

export default new BannerService();